import { render, staticRenderFns } from "./Snooze.vue?vue&type=template&id=4f230480"
import script from "./Snooze.vue?vue&type=script&lang=js"
export * from "./Snooze.vue?vue&type=script&lang=js"
import style0 from "./Snooze.vue?vue&type=style&index=0&id=4f230480&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports